










import { Vue, Component } from 'vue-property-decorator';
import Peajes from '@/pantallas/Peajes/Mantencion/Peajes.vue';

@Component({
  components: { Peajes },
})
export default class PeajesPantalla extends Vue {}
